import { render } from "./GenericDataItem.vue?vue&type=template&id=2d96b256"
import script from "./GenericDataItem.vue?vue&type=script&lang=js"
export * from "./GenericDataItem.vue?vue&type=script&lang=js"

import "./GenericDataItem.vue?vue&type=style&index=0&id=2d96b256&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__